import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import madeInFranceImage from "../../../assets/smarthome/Made_in_France.png";
import ProductCard from "../../products/productCaroussel/ProductCard";
import ProductCarousel from "../../products/productCaroussel/ProductCarrousel";
import COMMAND_1 from "../../../assets/products/COMMAND_1.png";
import CONTROLLERDIN_1 from "../../../assets/products/CONTROLLERDIN_1.png";
import MULTISWITCHDIN_1 from "../../../assets/products/MULTISWITCHDIN_1.png";
import SWITCHDIN_1 from "../../../assets/products/SWITCHDIN_1.png";
import MULTISWITCH_1 from "../../../assets/products/MULTISWITCH_1.png";
import MULTISWITCH_2 from "../../../assets/products/MULTISWITCH_2.png";
import SWITCH_1 from "../../../assets/products/SWITCH_1.png";
import REPEATER_1 from "../../../assets/products/REPEATER_1.png";
import THERMOSTAT_1W from "../../../assets/products/THERMOSTAT_1W.png";
import OPEN_1 from "../../../assets/products/OPEN_1.png";
import MOTIONLIGHT_1 from "../../../assets/products/MOTIONLIGHT_1.png";
import ENERGY1PN_1 from "../../../assets/products/ENERGY1PN_1.png";

export default function ProductSection(props) {
  const { textContent, language } = { ...props };

  const screenWidth = useSelector((state) => state.screen.screenWidth);
  const isMobile = useSelector((state) => state.screen.isMobile);

  const productMeta = (productKey, image) => {
    return {
      title:
        textContent.productSection.items.products.productsList[productKey]
          .subtitle[language],
      subtitle:
        textContent.productSection.items.products.productsList[productKey]
          .description[language],
      image,
      productURL:
        textContent.productSection.items.products.productsList[productKey].link,
    };
  };

  const products = [
    {
      title:
        textContent.productSection.items.products.productsList.COMMAND_1
          .subtitle[language],
      subtitle:
        textContent.productSection.items.products.productsList.COMMAND_1
          .description[language],
      image: COMMAND_1,
      productURL:
        textContent.productSection.items.products.productsList.COMMAND_1.link,
    },
    {
      title:
        textContent.productSection.items.products.productsList.COMMAND_1
          .subtitle[language],
      subtitle:
        textContent.productSection.items.products.productsList.COMMAND_1
          .description[language],
      image: COMMAND_1,
      productURL:
        textContent.productSection.items.products.productsList.COMMAND_1.link,
    },
  ];

  return (
    <section className="container">
      {isMobile ? (
        <div className="container-empty-extra-small" />
      ) : (
        <div className="container-empty-medium" />
      )}
      <div
        className={
          isMobile ? "product-title-section-mobile" : "product-title-section"
        }
      >
        <div className="container-small">
          <h1 className="title-gradient">
            {textContent.productSection.items.products.title[language]}
          </h1>
          <h2>
            {textContent.productSection.items.products.subtitle[language]}
          </h2>
        </div>

        {!isMobile ? (
          <div className="made-in-france">
            <img src={madeInFranceImage} />
          </div>
        ) : null}
      </div>
      {isMobile ? null : <div className="container-empty-small" />}
      <ProductCarousel
        products={[
          <ProductCard {...productMeta("CONTROLLERDIN_1", CONTROLLERDIN_1)} />,
          <ProductCard
            {...productMeta("MULTISWITCHDIN_1", MULTISWITCHDIN_1)}
          />,
          <ProductCard {...productMeta("SWITCHDIN_1", SWITCHDIN_1)} />,
          <ProductCard {...productMeta("MULTISWITCH_1", MULTISWITCH_1)} />,
          <ProductCard {...productMeta("MULTISWITCH_2", MULTISWITCH_2)} />,
          <ProductCard {...productMeta("SWITCH_1", SWITCH_1)} />,
          <ProductCard {...productMeta("THERMOSTAT_1W", THERMOSTAT_1W)} />,
          <ProductCard {...productMeta("COMMAND_1", COMMAND_1)} />,
          <ProductCard {...productMeta("OPEN_1", OPEN_1)} />,
          <ProductCard {...productMeta("MOTIONLIGHT_1", MOTIONLIGHT_1)} />,
          <ProductCard {...productMeta("ENERGY1PN_1", ENERGY1PN_1)} />,
          <ProductCard {...productMeta("REPEATER_1", REPEATER_1)} />,
        ]}
      />
    </section>
  );
}
